// Runtime feature flags, injected per environment through env-config.js
// (nginx/30-generate-env-config.sh) so they can be switched without a rebuild.

// AI-bot checks (PIN-328). The API refuses them unless its own AIBOT_ENABLED
// is on too; this flag only decides whether the cabinet offers them.
export function aiBotEnabled() {
  return String(window.ENV && window.ENV.AIBOT_ENABLED) === 'true';
}
